import {CmsPage, CmsPageType} from '@web-libs/features/cms/domain/cms.types';
import {DomainError} from '@web-libs/core/shared-domain/shared-domain.errors';
import {useState} from 'react';
import {useInstitutionContext} from '@web-libs/features/institution/application/use-institution-context';

export type FetchCmsPageFunction = (instId: string, identifier: CmsPageType) => Promise<CmsPage>;

export const _useCmsPage = (_fetchCmsPage: FetchCmsPageFunction) => {
    const [cmsPage, setCmsPage] = useState<CmsPage | null>(null);
    const [error, setError] = useState<DomainError | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const institutionId =  useInstitutionContext()

    const fetchCmsPage = async (identifier: CmsPageType) => {
        setLoading(true);
        try {
            const cmsPage = await _fetchCmsPage(institutionId, identifier);
            setCmsPage(cmsPage);
            return cmsPage;
        } catch (e) {
            if (e instanceof DomainError) {
                setError(e);
                return;
            }
            throw e;
        } finally {
            setLoading(false);
        }
    };

    return {
        fetchCmsPage,
        cmsPage,
        error,
        loading
    };
};
